import { Box, keyframes, styled } from '@driftt/dds'

const pulseAnimation = keyframes({
  '0%': {
    transform: 'scale(.95)',
    boxShadow: '0 0 0 0 rgba(19, 203, 110, 0.6)'
  },
  '70%': {
    transform: 'scale(1)',
    boxShadow: '0 0 0 8px rgba(19, 203, 110, 0)'
  },
  '100%': {
    transform: 'scale(.95)',
    boxShadow: '0 0 0 0 rgba(19, 203, 110, 0)'
  }
})

const StatusIcon = styled(Box, {
  animation: `${pulseAnimation} 1s linear infinite`,
  height: '10px',
  width: '10px',
  borderRadius: '50%',
  backgroundColor: 'rgb(19, 203, 110)'
})

export default StatusIcon
